module.exports = __webpack_public_path__ + "static/media/students-writing.5e166559.jpeg";